import { render, staticRenderFns } from "./KeyboardUI.vue?vue&type=template&id=eb298fce"
import script from "./KeyboardUI.vue?vue&type=script&lang=js"
export * from "./KeyboardUI.vue?vue&type=script&lang=js"
import style0 from "./KeyboardUI.vue?vue&type=style&index=0&id=eb298fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports